// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "./node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "./node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `*, ::before, ::after {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
  --tw-contain-size:  ;
  --tw-contain-layout:  ;
  --tw-contain-paint:  ;
  --tw-contain-style:  ;
}

::backdrop {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
  --tw-contain-size:  ;
  --tw-contain-layout:  ;
  --tw-contain-paint:  ;
  --tw-contain-style:  ;
}/*
! tailwindcss v3.4.17 | MIT License | https://tailwindcss.com
*//*
1. Prevent padding and border from affecting element width. (https://github.com/mozdevs/cssremedy/issues/4)
2. Allow adding a border to an element by just adding a border-width. (https://github.com/tailwindcss/tailwindcss/pull/116)
*/

*,
::before,
::after {
  box-sizing: border-box; /* 1 */
  border-width: 0; /* 2 */
  border-style: solid; /* 2 */
  border-color: #e5e7eb; /* 2 */
}

::before,
::after {
  --tw-content: '';
}

/*
1. Use a consistent sensible line-height in all browsers.
2. Prevent adjustments of font size after orientation changes in iOS.
3. Use a more readable tab size.
4. Use the user's configured \`sans\` font-family by default.
5. Use the user's configured \`sans\` font-feature-settings by default.
6. Use the user's configured \`sans\` font-variation-settings by default.
7. Disable tap highlights on iOS
*/

html,
:host {
  line-height: 1.5; /* 1 */
  -webkit-text-size-adjust: 100%; /* 2 */
  -moz-tab-size: 4; /* 3 */
  -o-tab-size: 4;
     tab-size: 4; /* 3 */
  font-family: ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"; /* 4 */
  font-feature-settings: normal; /* 5 */
  font-variation-settings: normal; /* 6 */
  -webkit-tap-highlight-color: transparent; /* 7 */
}

/*
1. Remove the margin in all browsers.
2. Inherit line-height from \`html\` so users can set them as a class directly on the \`html\` element.
*/

body {
  margin: 0; /* 1 */
  line-height: inherit; /* 2 */
}

/*
1. Add the correct height in Firefox.
2. Correct the inheritance of border color in Firefox. (https://bugzilla.mozilla.org/show_bug.cgi?id=190655)
3. Ensure horizontal rules are visible by default.
*/

hr {
  height: 0; /* 1 */
  color: inherit; /* 2 */
  border-top-width: 1px; /* 3 */
}

/*
Add the correct text decoration in Chrome, Edge, and Safari.
*/

abbr:where([title]) {
  -webkit-text-decoration: underline dotted;
          text-decoration: underline dotted;
}

/*
Remove the default font size and weight for headings.
*/

h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: inherit;
  font-weight: inherit;
}

/*
Reset links to optimize for opt-in styling instead of opt-out.
*/

a {
  color: inherit;
  text-decoration: inherit;
}

/*
Add the correct font weight in Edge and Safari.
*/

b,
strong {
  font-weight: bolder;
}

/*
1. Use the user's configured \`mono\` font-family by default.
2. Use the user's configured \`mono\` font-feature-settings by default.
3. Use the user's configured \`mono\` font-variation-settings by default.
4. Correct the odd \`em\` font sizing in all browsers.
*/

code,
kbd,
samp,
pre {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace; /* 1 */
  font-feature-settings: normal; /* 2 */
  font-variation-settings: normal; /* 3 */
  font-size: 1em; /* 4 */
}

/*
Add the correct font size in all browsers.
*/

small {
  font-size: 80%;
}

/*
Prevent \`sub\` and \`sup\` elements from affecting the line height in all browsers.
*/

sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}

/*
1. Remove text indentation from table contents in Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=999088, https://bugs.webkit.org/show_bug.cgi?id=201297)
2. Correct table border color inheritance in all Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=935729, https://bugs.webkit.org/show_bug.cgi?id=195016)
3. Remove gaps between table borders by default.
*/

table {
  text-indent: 0; /* 1 */
  border-color: inherit; /* 2 */
  border-collapse: collapse; /* 3 */
}

/*
1. Change the font styles in all browsers.
2. Remove the margin in Firefox and Safari.
3. Remove default padding in all browsers.
*/

button,
input,
optgroup,
select,
textarea {
  font-family: inherit; /* 1 */
  font-feature-settings: inherit; /* 1 */
  font-variation-settings: inherit; /* 1 */
  font-size: 100%; /* 1 */
  font-weight: inherit; /* 1 */
  line-height: inherit; /* 1 */
  letter-spacing: inherit; /* 1 */
  color: inherit; /* 1 */
  margin: 0; /* 2 */
  padding: 0; /* 3 */
}

/*
Remove the inheritance of text transform in Edge and Firefox.
*/

button,
select {
  text-transform: none;
}

/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Remove default button styles.
*/

button,
input:where([type='button']),
input:where([type='reset']),
input:where([type='submit']) {
  -webkit-appearance: button; /* 1 */
  background-color: transparent; /* 2 */
  background-image: none; /* 2 */
}

/*
Use the modern Firefox focus style for all focusable elements.
*/

:-moz-focusring {
  outline: auto;
}

/*
Remove the additional \`:invalid\` styles in Firefox. (https://github.com/mozilla/gecko-dev/blob/2f9eacd9d3d995c937b4251a5557d95d494c9be1/layout/style/res/forms.css#L728-L737)
*/

:-moz-ui-invalid {
  box-shadow: none;
}

/*
Add the correct vertical alignment in Chrome and Firefox.
*/

progress {
  vertical-align: baseline;
}

/*
Correct the cursor style of increment and decrement buttons in Safari.
*/

::-webkit-inner-spin-button,
::-webkit-outer-spin-button {
  height: auto;
}

/*
1. Correct the odd appearance in Chrome and Safari.
2. Correct the outline style in Safari.
*/

[type='search'] {
  -webkit-appearance: textfield; /* 1 */
  outline-offset: -2px; /* 2 */
}

/*
Remove the inner padding in Chrome and Safari on macOS.
*/

::-webkit-search-decoration {
  -webkit-appearance: none;
}

/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Change font properties to \`inherit\` in Safari.
*/

::-webkit-file-upload-button {
  -webkit-appearance: button; /* 1 */
  font: inherit; /* 2 */
}

/*
Add the correct display in Chrome and Safari.
*/

summary {
  display: list-item;
}

/*
Removes the default spacing and border for appropriate elements.
*/

blockquote,
dl,
dd,
h1,
h2,
h3,
h4,
h5,
h6,
hr,
figure,
p,
pre {
  margin: 0;
}

fieldset {
  margin: 0;
  padding: 0;
}

legend {
  padding: 0;
}

ol,
ul,
menu {
  list-style: none;
  margin: 0;
  padding: 0;
}

/*
Reset default styling for dialogs.
*/
dialog {
  padding: 0;
}

/*
Prevent resizing textareas horizontally by default.
*/

textarea {
  resize: vertical;
}

/*
1. Reset the default placeholder opacity in Firefox. (https://github.com/tailwindlabs/tailwindcss/issues/3300)
2. Set the default placeholder color to the user's configured gray 400 color.
*/

input::-moz-placeholder, textarea::-moz-placeholder {
  opacity: 1; /* 1 */
  color: #9ca3af; /* 2 */
}

input::placeholder,
textarea::placeholder {
  opacity: 1; /* 1 */
  color: #9ca3af; /* 2 */
}

/*
Set the default cursor for buttons.
*/

button,
[role="button"] {
  cursor: pointer;
}

/*
Make sure disabled buttons don't get the pointer cursor.
*/
:disabled {
  cursor: default;
}

/*
1. Make replaced elements \`display: block\` by default. (https://github.com/mozdevs/cssremedy/issues/14)
2. Add \`vertical-align: middle\` to align replaced elements more sensibly by default. (https://github.com/jensimmons/cssremedy/issues/14#issuecomment-634934210)
   This can trigger a poorly considered lint error in some tools but is included by design.
*/

img,
svg,
video,
canvas,
audio,
iframe,
embed,
object {
  display: block; /* 1 */
  vertical-align: middle; /* 2 */
}

/*
Constrain images and videos to the parent width and preserve their intrinsic aspect ratio. (https://github.com/mozdevs/cssremedy/issues/14)
*/

img,
video {
  max-width: 100%;
  height: auto;
}

/* Make elements with the HTML hidden attribute stay hidden by default */
[hidden]:where(:not([hidden="until-found"])) {
  display: none;
}html{color:#4a4a4a;font-family:poppins,"Verdana",sans-serif;font-size:15px}.container {
  width: 100%;
}@media (min-width: 640px) {

  .container {
    max-width: 640px;
  }
}@media (min-width: 768px) {

  .container {
    max-width: 768px;
  }
}@media (min-width: 1024px) {

  .container {
    max-width: 1024px;
  }
}@media (min-width: 1280px) {

  .container {
    max-width: 1280px;
  }
}@media (min-width: 1536px) {

  .container {
    max-width: 1536px;
  }
}.visible {
  visibility: visible;
}.static {
  position: static;
}.fixed {
  position: fixed;
}.absolute {
  position: absolute;
}.relative {
  position: relative;
}.sticky {
  position: sticky;
}.bottom-\\[0\\] {
  bottom: 0;
}.left-0 {
  left: 0px;
}.top-0 {
  top: 0px;
}.mx-0 {
  margin-left: 0px;
  margin-right: 0px;
}.mx-\\[auto\\] {
  margin-left: auto;
  margin-right: auto;
}.my-\\[0\\] {
  margin-top: 0;
  margin-bottom: 0;
}.mb-12 {
  margin-bottom: 3rem;
}.block {
  display: block;
}.inline {
  display: inline;
}.flex {
  display: flex;
}.inline-flex {
  display: inline-flex;
}.table {
  display: table;
}.hidden {
  display: none;
}.h-16 {
  height: 4rem;
}.h-20 {
  height: 5rem;
}.h-5 {
  height: 1.25rem;
}.h-6 {
  height: 1.5rem;
}.h-\\[24px\\] {
  height: 24px;
}.h-\\[55px\\] {
  height: 55px;
}.h-\\[74px\\] {
  height: 74px;
}.h-\\[80px\\] {
  height: 80px;
}.h-full {
  height: 100%;
}.w-16 {
  width: 4rem;
}.w-5 {
  width: 1.25rem;
}.w-72 {
  width: 18rem;
}.w-80 {
  width: 20rem;
}.w-96 {
  width: 24rem;
}.w-\\[24px\\] {
  width: 24px;
}.w-\\[55px\\] {
  width: 55px;
}.w-\\[74px\\] {
  width: 74px;
}.w-auto {
  width: auto;
}.w-full {
  width: 100%;
}.min-w-\\[240px\\] {
  min-width: 240px;
}.max-w-\\[1140px\\] {
  max-width: 1140px;
}.max-w-\\[500px\\] {
  max-width: 500px;
}.flex-\\[0_0_100\\%\\] {
  flex: 0 0 100%;
}.flex-\\[1_0_0\\] {
  flex: 1 0 0;
}.flex-shrink-0 {
  flex-shrink: 0;
}.shrink {
  flex-shrink: 1;
}.grow {
  flex-grow: 1;
}.basis-0 {
  flex-basis: 0px;
}.transform {
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}.cursor-pointer {
  cursor: pointer;
}.resize {
  resize: both;
}.flex-row {
  flex-direction: row;
}.flex-col {
  flex-direction: column;
}.flex-col-reverse {
  flex-direction: column-reverse;
}.flex-wrap {
  flex-wrap: wrap;
}.items-start {
  align-items: flex-start;
}.items-end {
  align-items: flex-end;
}.items-center {
  align-items: center;
}.justify-start {
  justify-content: flex-start;
}.justify-end {
  justify-content: flex-end;
}.justify-center {
  justify-content: center;
}.gap-0 {
  gap: 0px;
}.gap-1 {
  gap: 0.25rem;
}.gap-1\\.5 {
  gap: 0.375rem;
}.gap-10 {
  gap: 2.5rem;
}.gap-16 {
  gap: 4rem;
}.gap-2 {
  gap: 0.5rem;
}.gap-2\\.5 {
  gap: 0.625rem;
}.gap-3 {
  gap: 0.75rem;
}.gap-3\\.5 {
  gap: 0.875rem;
}.gap-4 {
  gap: 1rem;
}.gap-5 {
  gap: 1.25rem;
}.gap-6 {
  gap: 1.5rem;
}.gap-8 {
  gap: 2rem;
}.gap-\\[16px\\] {
  gap: 16px;
}.gap-\\[20px\\] {
  gap: 20px;
}.gap-\\[24px\\] {
  gap: 24px;
}.gap-\\[32px\\] {
  gap: 32px;
}.gap-\\[40px\\] {
  gap: 40px;
}.gap-\\[4px\\] {
  gap: 4px;
}.self-stretch {
  align-self: stretch;
}.overflow-hidden {
  overflow: hidden;
}.rounded-2xl {
  border-radius: 1rem;
}.rounded-\\[100px\\] {
  border-radius: 100px;
}.rounded-\\[18px\\] {
  border-radius: 18px;
}.rounded-\\[30px\\] {
  border-radius: 30px;
}.rounded-\\[32px\\] {
  border-radius: 32px;
}.rounded-\\[45px\\] {
  border-radius: 45px;
}.rounded-\\[48px\\] {
  border-radius: 48px;
}.rounded-\\[60px\\] {
  border-radius: 60px;
}.rounded-lg {
  border-radius: 0.5rem;
}.rounded-xl {
  border-radius: 0.75rem;
}.border {
  border-width: 1px;
}.border-2 {
  border-width: 2px;
}.border-8 {
  border-width: 8px;
}.border-\\[1px\\] {
  border-width: 1px;
}.border-b {
  border-bottom-width: 1px;
}.border-r {
  border-right-width: 1px;
}.border-t {
  border-top-width: 1px;
}.border-\\[\\#838df1\\] {
  --tw-border-opacity: 1;
  border-color: rgb(131 141 241 / var(--tw-border-opacity, 1));
}.border-\\[\\#97a0f3\\] {
  --tw-border-opacity: 1;
  border-color: rgb(151 160 243 / var(--tw-border-opacity, 1));
}.border-\\[\\#F9ECE5\\] {
  --tw-border-opacity: 1;
  border-color: rgb(249 236 229 / var(--tw-border-opacity, 1));
}.border-\\[\\#cfd3f9\\] {
  --tw-border-opacity: 1;
  border-color: rgb(207 211 249 / var(--tw-border-opacity, 1));
}.border-\\[\\#d0d5dd\\] {
  --tw-border-opacity: 1;
  border-color: rgb(208 213 221 / var(--tw-border-opacity, 1));
}.border-\\[solid\\] {
  border-color: solid;
}.border-stone-300 {
  --tw-border-opacity: 1;
  border-color: rgb(214 211 209 / var(--tw-border-opacity, 1));
}.bg-\\[\\#434ca0\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(67 76 160 / var(--tw-bg-opacity, 1));
}.bg-\\[\\#F9ECE5\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(249 236 229 / var(--tw-bg-opacity, 1));
}.bg-\\[\\#eaecf0\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(234 236 240 / var(--tw-bg-opacity, 1));
}.bg-\\[\\#f0f1fd\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(240 241 253 / var(--tw-bg-opacity, 1));
}.bg-\\[white\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
}.bg-gray-50 {
  --tw-bg-opacity: 1;
  background-color: rgb(249 250 251 / var(--tw-bg-opacity, 1));
}.bg-white {
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
}.bg-\\[url\\(https\\:\\/\\/cdn\\.homeandmoney\\.com\\/wp-content\\/uploads\\/2023\\/10\\/12123118\\/Pattern-bottom-bar-lotus\\.webp\\)\\] {
  background-image: url(https://cdn.homeandmoney.com/wp-content/uploads/2023/10/12123118/Pattern-bottom-bar-lotus.webp);
}.bg-gradient-to-bl {
  background-image: linear-gradient(to bottom left, var(--tw-gradient-stops));
}.from-\\[\\#f9e0d6\\] {
  --tw-gradient-from: #f9e0d6 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(249 224 214 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}.to-\\[\\#f3bda7\\] {
  --tw-gradient-to: #f3bda7 var(--tw-gradient-to-position);
}.bg-auto {
  background-size: auto;
}.bg-bottom {
  background-position: bottom;
}.bg-no-repeat {
  background-repeat: no-repeat;
}.object-cover {
  -o-object-fit: cover;
     object-fit: cover;
}.object-center {
  -o-object-position: center;
     object-position: center;
}.p-2 {
  padding: 0.5rem;
}.p-4 {
  padding: 1rem;
}.p-6 {
  padding: 1.5rem;
}.p-\\[10px\\] {
  padding: 10px;
}.px-0 {
  padding-left: 0px;
  padding-right: 0px;
}.px-11 {
  padding-left: 2.75rem;
  padding-right: 2.75rem;
}.px-12 {
  padding-left: 3rem;
  padding-right: 3rem;
}.px-4 {
  padding-left: 1rem;
  padding-right: 1rem;
}.px-8 {
  padding-left: 2rem;
  padding-right: 2rem;
}.px-\\[16px\\] {
  padding-left: 16px;
  padding-right: 16px;
}.px-\\[24px\\] {
  padding-left: 24px;
  padding-right: 24px;
}.px-\\[32px\\] {
  padding-left: 32px;
  padding-right: 32px;
}.py-0 {
  padding-top: 0px;
  padding-bottom: 0px;
}.py-2 {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}.py-4 {
  padding-top: 1rem;
  padding-bottom: 1rem;
}.py-6 {
  padding-top: 1.5rem;
  padding-bottom: 1.5rem;
}.py-\\[24px\\] {
  padding-top: 24px;
  padding-bottom: 24px;
}.py-\\[25px\\] {
  padding-top: 25px;
  padding-bottom: 25px;
}.py-\\[40px\\] {
  padding-top: 40px;
  padding-bottom: 40px;
}.py-\\[64px\\] {
  padding-top: 64px;
  padding-bottom: 64px;
}.pb-0 {
  padding-bottom: 0px;
}.pb-2\\.5 {
  padding-bottom: 0.625rem;
}.pb-4 {
  padding-bottom: 1rem;
}.pb-\\[48px\\] {
  padding-bottom: 48px;
}.pl-6 {
  padding-left: 1.5rem;
}.pl-\\[24px\\] {
  padding-left: 24px;
}.pr-6 {
  padding-right: 1.5rem;
}.pr-7 {
  padding-right: 1.75rem;
}.pr-\\[24px\\] {
  padding-right: 24px;
}.pt-1 {
  padding-top: 0.25rem;
}.pt-16 {
  padding-top: 4rem;
}.pt-6 {
  padding-top: 1.5rem;
}.pt-8 {
  padding-top: 2rem;
}.pt-\\[\\.75rem\\] {
  padding-top: .75rem;
}.pt-\\[48px\\] {
  padding-top: 48px;
}.text-center {
  text-align: center;
}.font-\\[Poppins\\] {
  font-family: Poppins;
}.font-new-spirit {
  font-family: "new-spirit", sans-serif;
}.font-poppins {
  font-family: "Poppins", sans-serif;
}.text-2xl {
  font-size: 1.5rem;
  line-height: 2rem;
}.text-\\[14px\\] {
  font-size: 14px;
}.text-\\[16px\\] {
  font-size: 16px;
}.text-\\[17px\\] {
  font-size: 17px;
}.text-\\[19px\\] {
  font-size: 19px;
}.text-\\[20px\\] {
  font-size: 20px;
}.text-\\[22px\\] {
  font-size: 22px;
}.text-\\[27px\\] {
  font-size: 27px;
}.text-\\[32px\\] {
  font-size: 32px;
}.font-bold {
  font-weight: 700;
}.font-medium {
  font-weight: 500;
}.font-normal {
  font-weight: 400;
}.font-semibold {
  font-weight: 600;
}.capitalize {
  text-transform: capitalize;
}.italic {
  font-style: italic;
}.not-italic {
  font-style: normal;
}.leading-\\[100\\%\\] {
  line-height: 100%;
}.leading-\\[120\\%\\] {
  line-height: 120%;
}.leading-\\[135\\%\\] {
  line-height: 135%;
}.leading-\\[150\\%\\] {
  line-height: 150%;
}.leading-\\[20px\\] {
  line-height: 20px;
}.leading-\\[52\\.65px\\] {
  line-height: 52.65px;
}.leading-none {
  line-height: 1;
}.leading-normal {
  line-height: 1.5;
}.leading-tight {
  line-height: 1.25;
}.tracking-\\[-0\\.4px\\] {
  letter-spacing: -0.4px;
}.tracking-\\[-0\\.5px\\] {
  letter-spacing: -0.5px;
}.tracking-\\[-0\\.84px\\] {
  letter-spacing: -0.84px;
}.text-\\[\\#2A2F64\\] {
  --tw-text-opacity: 1;
  color: rgb(42 47 100 / var(--tw-text-opacity, 1));
}.text-\\[\\#2a2f64\\] {
  --tw-text-opacity: 1;
  color: rgb(42 47 100 / var(--tw-text-opacity, 1));
}.text-\\[\\#434ca0\\] {
  --tw-text-opacity: 1;
  color: rgb(67 76 160 / var(--tw-text-opacity, 1));
}.text-\\[\\#5B3C2F\\] {
  --tw-text-opacity: 1;
  color: rgb(91 60 47 / var(--tw-text-opacity, 1));
}.text-\\[\\#5b3c2f\\] {
  --tw-text-opacity: 1;
  color: rgb(91 60 47 / var(--tw-text-opacity, 1));
}.text-\\[\\#6471ed\\] {
  --tw-text-opacity: 1;
  color: rgb(100 113 237 / var(--tw-text-opacity, 1));
}.text-\\[\\#667085\\] {
  --tw-text-opacity: 1;
  color: rgb(102 112 133 / var(--tw-text-opacity, 1));
}.text-\\[\\#FFF\\] {
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}.text-\\[rgb\\(42\\2c 47\\2c 100\\)\\] {
  --tw-text-opacity: 1;
  color: rgb(42 47 100 / var(--tw-text-opacity, 1));
}.text-\\[rgba\\(100\\2c _66\\2c _52\\2c _0\\.75\\)\\] {
  color: rgba(100, 66, 52, 0.75);
}.text-slate-700 {
  --tw-text-opacity: 1;
  color: rgb(51 65 85 / var(--tw-text-opacity, 1));
}.text-white {
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}.antialiased {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}.shadow {
  --tw-shadow: 0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 1px 3px 0 var(--tw-shadow-color), 0 1px 2px -1px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}.blur {
  --tw-blur: blur(8px);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}.filter {
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}.backdrop-filter {
  -webkit-backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
  backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}.transition {
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, -webkit-backdrop-filter;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter, -webkit-backdrop-filter;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}.ease-in-out {
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
}.hover\\:bg-\\[\\#2E3570\\]:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(46 53 112 / var(--tw-bg-opacity, 1));
}.hover\\:bg-\\[\\#D0D5DD\\]:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(208 213 221 / var(--tw-bg-opacity, 1));
}.hover\\:bg-\\[\\#F2F4F7\\]:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(242 244 247 / var(--tw-bg-opacity, 1));
}.hover\\:from-\\[\\#f3bda7\\]:hover {
  --tw-gradient-from: #f3bda7 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(243 189 167 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}.hover\\:to-\\[\\#f3bda7\\]:hover {
  --tw-gradient-to: #f3bda7 var(--tw-gradient-to-position);
}@media (min-width: 640px) {

  .sm\\:mx-\\[48px\\] {
    margin-left: 48px;
    margin-right: 48px;
  }

  .sm\\:my-\\[40px\\] {
    margin-top: 40px;
    margin-bottom: 40px;
  }

  .sm\\:w-auto {
    width: auto;
  }

  .sm\\:max-w-\\[670px\\] {
    max-width: 670px;
  }

  .sm\\:flex-row {
    flex-direction: row;
  }

  .sm\\:gap-5 {
    gap: 1.25rem;
  }

  .sm\\:rounded-\\[48px\\] {
    border-radius: 48px;
  }

  .sm\\:px-6 {
    padding-left: 1.5rem;
    padding-right: 1.5rem;
  }

  .sm\\:px-\\[48px\\] {
    padding-left: 48px;
    padding-right: 48px;
  }

  .sm\\:py-8 {
    padding-top: 2rem;
    padding-bottom: 2rem;
  }

  .sm\\:py-\\[56px\\] {
    padding-top: 56px;
    padding-bottom: 56px;
  }

  .sm\\:py-\\[64px\\] {
    padding-top: 64px;
    padding-bottom: 64px;
  }

  .sm\\:pl-\\[48px\\] {
    padding-left: 48px;
  }

  .sm\\:pr-\\[48px\\] {
    padding-right: 48px;
  }

  .sm\\:text-\\[20px\\] {
    font-size: 20px;
  }

  .sm\\:text-\\[25px\\] {
    font-size: 25px;
  }

  .sm\\:text-\\[39px\\] {
    font-size: 39px;
  }

  .sm\\:text-\\[42px\\] {
    font-size: 42px;
  }

  .sm\\:leading-\\[52\\.65px\\] {
    line-height: 52.65px;
  }
}@media (min-width: 768px) {

  .md\\:sticky {
    position: sticky;
  }

  .md\\:w-\\[353px\\] {
    width: 353px;
  }

  .md\\:max-w-\\[1140px\\] {
    max-width: 1140px;
  }

  .md\\:flex-row-reverse {
    flex-direction: row-reverse;
  }

  .md\\:pt-\\[24px\\] {
    padding-top: 24px;
  }
}@media (min-width: 1024px) {

  .lg\\:flex {
    display: flex;
  }

  .lg\\:hidden {
    display: none;
  }

  .lg\\:w-1\\/2 {
    width: 50%;
  }

  .lg\\:w-auto {
    width: auto;
  }

  .lg\\:w-full {
    width: 100%;
  }

  .lg\\:max-w-\\[1140px\\] {
    max-width: 1140px;
  }

  .lg\\:flex-row {
    flex-direction: row;
  }

  .lg\\:flex-col {
    flex-direction: column;
  }

  .lg\\:items-center {
    align-items: center;
  }

  .lg\\:gap-4 {
    gap: 1rem;
  }
}`, "",{"version":3,"sources":["webpack://./tailwind.css"],"names":[],"mappings":"AAAA;EAAA,wBAAA;EAAA,wBAAA;EAAA,mBAAA;EAAA,mBAAA;EAAA,cAAA;EAAA,cAAA;EAAA,cAAA;EAAA,eAAA;EAAA,eAAA;EAAA,aAAA;EAAA,aAAA;EAAA,kBAAA;EAAA,sCAAA;EAAA,8BAAA;EAAA,6BAAA;EAAA,4BAAA;EAAA,eAAA;EAAA,oBAAA;EAAA,sBAAA;EAAA,uBAAA;EAAA,wBAAA;EAAA,kBAAA;EAAA,2BAAA;EAAA,4BAAA;EAAA,sCAAA;EAAA,kCAAA;EAAA,2BAAA;EAAA,sBAAA;EAAA,8BAAA;EAAA,YAAA;EAAA,kBAAA;EAAA,gBAAA;EAAA,iBAAA;EAAA,kBAAA;EAAA,cAAA;EAAA,gBAAA;EAAA,aAAA;EAAA,mBAAA;EAAA,qBAAA;EAAA,2BAAA;EAAA,yBAAA;EAAA,0BAAA;EAAA,2BAAA;EAAA,uBAAA;EAAA,wBAAA;EAAA,yBAAA;EAAA,sBAAA;EAAA,oBAAA;EAAA,sBAAA;EAAA,qBAAA;EAAA;AAAA;;AAAA;EAAA,wBAAA;EAAA,wBAAA;EAAA,mBAAA;EAAA,mBAAA;EAAA,cAAA;EAAA,cAAA;EAAA,cAAA;EAAA,eAAA;EAAA,eAAA;EAAA,aAAA;EAAA,aAAA;EAAA,kBAAA;EAAA,sCAAA;EAAA,8BAAA;EAAA,6BAAA;EAAA,4BAAA;EAAA,eAAA;EAAA,oBAAA;EAAA,sBAAA;EAAA,uBAAA;EAAA,wBAAA;EAAA,kBAAA;EAAA,2BAAA;EAAA,4BAAA;EAAA,sCAAA;EAAA,kCAAA;EAAA,2BAAA;EAAA,sBAAA;EAAA,8BAAA;EAAA,YAAA;EAAA,kBAAA;EAAA,gBAAA;EAAA,iBAAA;EAAA,kBAAA;EAAA,cAAA;EAAA,gBAAA;EAAA,aAAA;EAAA,mBAAA;EAAA,qBAAA;EAAA,2BAAA;EAAA,yBAAA;EAAA,0BAAA;EAAA,2BAAA;EAAA,uBAAA;EAAA,wBAAA;EAAA,yBAAA;EAAA,sBAAA;EAAA,oBAAA;EAAA,sBAAA;EAAA,qBAAA;EAAA;AAAA,CAAA;;CAAA,CAAA;;;CAAA;;AAAA;;;EAAA,sBAAA,EAAA,MAAA;EAAA,eAAA,EAAA,MAAA;EAAA,mBAAA,EAAA,MAAA;EAAA,qBAAA,EAAA,MAAA;AAAA;;AAAA;;EAAA,gBAAA;AAAA;;AAAA;;;;;;;;CAAA;;AAAA;;EAAA,gBAAA,EAAA,MAAA;EAAA,8BAAA,EAAA,MAAA;EAAA,gBAAA,EAAA,MAAA;EAAA,cAAA;KAAA,WAAA,EAAA,MAAA;EAAA,+HAAA,EAAA,MAAA;EAAA,6BAAA,EAAA,MAAA;EAAA,+BAAA,EAAA,MAAA;EAAA,wCAAA,EAAA,MAAA;AAAA;;AAAA;;;CAAA;;AAAA;EAAA,SAAA,EAAA,MAAA;EAAA,oBAAA,EAAA,MAAA;AAAA;;AAAA;;;;CAAA;;AAAA;EAAA,SAAA,EAAA,MAAA;EAAA,cAAA,EAAA,MAAA;EAAA,qBAAA,EAAA,MAAA;AAAA;;AAAA;;CAAA;;AAAA;EAAA,yCAAA;UAAA,iCAAA;AAAA;;AAAA;;CAAA;;AAAA;;;;;;EAAA,kBAAA;EAAA,oBAAA;AAAA;;AAAA;;CAAA;;AAAA;EAAA,cAAA;EAAA,wBAAA;AAAA;;AAAA;;CAAA;;AAAA;;EAAA,mBAAA;AAAA;;AAAA;;;;;CAAA;;AAAA;;;;EAAA,+GAAA,EAAA,MAAA;EAAA,6BAAA,EAAA,MAAA;EAAA,+BAAA,EAAA,MAAA;EAAA,cAAA,EAAA,MAAA;AAAA;;AAAA;;CAAA;;AAAA;EAAA,cAAA;AAAA;;AAAA;;CAAA;;AAAA;;EAAA,cAAA;EAAA,cAAA;EAAA,kBAAA;EAAA,wBAAA;AAAA;;AAAA;EAAA,eAAA;AAAA;;AAAA;EAAA,WAAA;AAAA;;AAAA;;;;CAAA;;AAAA;EAAA,cAAA,EAAA,MAAA;EAAA,qBAAA,EAAA,MAAA;EAAA,yBAAA,EAAA,MAAA;AAAA;;AAAA;;;;CAAA;;AAAA;;;;;EAAA,oBAAA,EAAA,MAAA;EAAA,8BAAA,EAAA,MAAA;EAAA,gCAAA,EAAA,MAAA;EAAA,eAAA,EAAA,MAAA;EAAA,oBAAA,EAAA,MAAA;EAAA,oBAAA,EAAA,MAAA;EAAA,uBAAA,EAAA,MAAA;EAAA,cAAA,EAAA,MAAA;EAAA,SAAA,EAAA,MAAA;EAAA,UAAA,EAAA,MAAA;AAAA;;AAAA;;CAAA;;AAAA;;EAAA,oBAAA;AAAA;;AAAA;;;CAAA;;AAAA;;;;EAAA,0BAAA,EAAA,MAAA;EAAA,6BAAA,EAAA,MAAA;EAAA,sBAAA,EAAA,MAAA;AAAA;;AAAA;;CAAA;;AAAA;EAAA,aAAA;AAAA;;AAAA;;CAAA;;AAAA;EAAA,gBAAA;AAAA;;AAAA;;CAAA;;AAAA;EAAA,wBAAA;AAAA;;AAAA;;CAAA;;AAAA;;EAAA,YAAA;AAAA;;AAAA;;;CAAA;;AAAA;EAAA,6BAAA,EAAA,MAAA;EAAA,oBAAA,EAAA,MAAA;AAAA;;AAAA;;CAAA;;AAAA;EAAA,wBAAA;AAAA;;AAAA;;;CAAA;;AAAA;EAAA,0BAAA,EAAA,MAAA;EAAA,aAAA,EAAA,MAAA;AAAA;;AAAA;;CAAA;;AAAA;EAAA,kBAAA;AAAA;;AAAA;;CAAA;;AAAA;;;;;;;;;;;;;EAAA,SAAA;AAAA;;AAAA;EAAA,SAAA;EAAA,UAAA;AAAA;;AAAA;EAAA,UAAA;AAAA;;AAAA;;;EAAA,gBAAA;EAAA,SAAA;EAAA,UAAA;AAAA;;AAAA;;CAAA;AAAA;EAAA,UAAA;AAAA;;AAAA;;CAAA;;AAAA;EAAA,gBAAA;AAAA;;AAAA;;;CAAA;;AAAA;EAAA,UAAA,EAAA,MAAA;EAAA,cAAA,EAAA,MAAA;AAAA;;AAAA;;EAAA,UAAA,EAAA,MAAA;EAAA,cAAA,EAAA,MAAA;AAAA;;AAAA;;CAAA;;AAAA;;EAAA,eAAA;AAAA;;AAAA;;CAAA;AAAA;EAAA,eAAA;AAAA;;AAAA;;;;CAAA;;AAAA;;;;;;;;EAAA,cAAA,EAAA,MAAA;EAAA,sBAAA,EAAA,MAAA;AAAA;;AAAA;;CAAA;;AAAA;;EAAA,eAAA;EAAA,YAAA;AAAA;;AAAA,wEAAA;AAAA;EAAA,aAAA;AAAA,CAAA,KAAA,aAAA,CAAA,wCAAA,CAAA,cAAA,CACA;EAAA;AAAA,CAAA;;EAAA;IAAA;EAAA;AAAA,CAAA;;EAAA;IAAA;EAAA;AAAA,CAAA;;EAAA;IAAA;EAAA;AAAA,CAAA;;EAAA;IAAA;EAAA;AAAA,CAAA;;EAAA;IAAA;EAAA;AAAA,CACA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA,gBAAA;EAAA;AAAA,CAAA;EAAA,iBAAA;EAAA;AAAA,CAAA;EAAA,aAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA,sBAAA;EAAA;AAAA,CAAA;EAAA,sBAAA;EAAA;AAAA,CAAA;EAAA,sBAAA;EAAA;AAAA,CAAA;EAAA,sBAAA;EAAA;AAAA,CAAA;EAAA,sBAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA,sBAAA;EAAA;AAAA,CAAA;EAAA,kBAAA;EAAA;AAAA,CAAA;EAAA,kBAAA;EAAA;AAAA,CAAA;EAAA,kBAAA;EAAA;AAAA,CAAA;EAAA,kBAAA;EAAA;AAAA,CAAA;EAAA,kBAAA;EAAA;AAAA,CAAA;EAAA,kBAAA;EAAA;AAAA,CAAA;EAAA,kBAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA,4DAAA;EAAA,qEAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA,oBAAA;KAAA;AAAA,CAAA;EAAA,0BAAA;KAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA,iBAAA;EAAA;AAAA,CAAA;EAAA,qBAAA;EAAA;AAAA,CAAA;EAAA,kBAAA;EAAA;AAAA,CAAA;EAAA,kBAAA;EAAA;AAAA,CAAA;EAAA,kBAAA;EAAA;AAAA,CAAA;EAAA,kBAAA;EAAA;AAAA,CAAA;EAAA,kBAAA;EAAA;AAAA,CAAA;EAAA,kBAAA;EAAA;AAAA,CAAA;EAAA,gBAAA;EAAA;AAAA,CAAA;EAAA,mBAAA;EAAA;AAAA,CAAA;EAAA,iBAAA;EAAA;AAAA,CAAA;EAAA,mBAAA;EAAA;AAAA,CAAA;EAAA,iBAAA;EAAA;AAAA,CAAA;EAAA,iBAAA;EAAA;AAAA,CAAA;EAAA,iBAAA;EAAA;AAAA,CAAA;EAAA,iBAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA,iBAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA,oBAAA;EAAA;AAAA,CAAA;EAAA,oBAAA;EAAA;AAAA,CAAA;EAAA,oBAAA;EAAA;AAAA,CAAA;EAAA,oBAAA;EAAA;AAAA,CAAA;EAAA,oBAAA;EAAA;AAAA,CAAA;EAAA,oBAAA;EAAA;AAAA,CAAA;EAAA,oBAAA;EAAA;AAAA,CAAA;EAAA,oBAAA;EAAA;AAAA,CAAA;EAAA,oBAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA,oBAAA;EAAA;AAAA,CAAA;EAAA,oBAAA;EAAA;AAAA,CAAA;EAAA,mCAAA;EAAA;AAAA,CAAA;EAAA,0EAAA;EAAA,8FAAA;EAAA;AAAA,CAAA;EAAA,oBAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA,+QAAA;EAAA;AAAA,CAAA;EAAA,gKAAA;EAAA,wJAAA;EAAA,iLAAA;EAAA,wDAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAFA;EAAA,kBASI;EATJ;AASI,CATJ;EAAA,kBASI;EATJ;AASI,CATJ;EAAA,kBASI;EATJ;AASI,CATJ;EAAA,4DASI;EATJ,qEASI;EATJ;AASI,CATJ;EAAA;AASI,CATJ;;EAAA;IAAA,iBASI;IATJ;EASI;;EATJ;IAAA,gBASI;IATJ;EASI;;EATJ;IAAA;EASI;;EATJ;IAAA;EASI;;EATJ;IAAA;EASI;;EATJ;IAAA;EASI;;EATJ;IAAA;EASI;;EATJ;IAAA,oBASI;IATJ;EASI;;EATJ;IAAA,kBASI;IATJ;EASI;;EATJ;IAAA,iBASI;IATJ;EASI;;EATJ;IAAA,iBASI;IATJ;EASI;;EATJ;IAAA,iBASI;IATJ;EASI;;EATJ;IAAA;EASI;;EATJ;IAAA;EASI;;EATJ;IAAA;EASI;;EATJ;IAAA;EASI;;EATJ;IAAA;EASI;;EATJ;IAAA;EASI;;EATJ;IAAA;EASI;AAAA,CATJ;;EAAA;IAAA;EASI;;EATJ;IAAA;EASI;;EATJ;IAAA;EASI;;EATJ;IAAA;EASI;;EATJ;IAAA;EASI;AAAA,CATJ;;EAAA;IAAA;EASI;;EATJ;IAAA;EASI;;EATJ;IAAA;EASI;;EATJ;IAAA;EASI;;EATJ;IAAA;EASI;;EATJ;IAAA;EASI;;EATJ;IAAA;EASI;;EATJ;IAAA;EASI;;EATJ;IAAA;EASI;;EATJ;IAAA;EASI;AAAA","sourcesContent":["@tailwind base;\n@tailwind components;\n@tailwind utilities;\n\n\n@layer base {\n  html {\n    color: #4A4A4A;\n    font-family: poppins, 'Verdana', sans-serif;\n    font-size: 15px;\n  }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
